<template>
  <validation-provider
    :rules="rules"
    v-slot="{ errors }"
  >
    <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
      <label class="label" :for="name">
        {{ label }}

        <span v-if="tip" :data-tooltip="tip">
          <ion-icon class="icon" name="help-circle-outline"></ion-icon>
        </span>
      </label>

      <input
        v-if="hasMask"
        type="text"
        class="form-control"
        :id="name"
        :name="name"
        :value="value"
        :disabled="disabled"
        v-mask="mask"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
      >
      <input
        v-else
        :type="[type === 'password' ? 'password' : 'text']"
        class="form-control"
        :id="name"
        :name="name"
        :value="value"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
      >

      <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
    </div>
  </validation-provider>
</template>

<script>
import { mask } from 'vue-the-mask';
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'InputField',

  props: {
    type: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    placeholder: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    value: {
      required: true,
    },
    tip: {
      required: false,
      type: String,
      default: '',
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    required: {
      required: false,
      type: Boolean,
    },
  },

  computed: {
    /**
     * Field has mask.
     *
     * @returns {boolean}
     */
    hasMask() {
      const typesHasMask = ['date', 'cpf', 'cnpj', 'cpfCnpj'];

      return typesHasMask.includes(this.type);
    },

    /**
     * Te mask to field.
     *
     * @returns {*|string|string[]}
     */
    mask() {
      const masksByTypes = {
        cnpj: '##.###.###/####-##',
        cpf: '###.###.###-##',
        cpfCnpj: ['###.###.###-##', '##.###.###/####-##'],
        date: '##/##/####',
      };

      return masksByTypes[this.type] || '';
    },

    rules() {
      if (this.disabled) {
        return '';
      }

      const rules = [];

      if (this.required) {
        rules.push('required');
      }

      const typesWithRules = ['cpf', 'cnpj', 'date', 'rg', 'cpfCnpj'];
      if (typesWithRules.includes(this.type)) {
        rules.push(this.type);
      }

      return rules.join('|');
    },
  },

  directives: {
    mask,
  },

  components: {
    ValidationProvider,
  },
};
</script>

<style scoped>

</style>
